import { data } from '../../svg/Contact/data';
import { makeIcon } from '../makeIcon';

export const Contact = makeIcon(data, 'contact', 'Contact');

export default Contact;
